module.exports = __webpack_public_path__ + "img/2.7f505d22.jpg";